// extracted by mini-css-extract-plugin
export var footer = "_oe-0";
export var inherit = "_oe-1";
export var input = "_oe-2";
export var modalContent = "_oe-3";
export var quillEditor = "_oe-4";
export var subtitle = "_oe-5";